// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"D1-z","displaySixCardTiles":"E1-z"};